<template>
  <div>
    <LoadingSpinner v-if="isLoading" />
    <div v-else>
      <PageHeader title="Edit Labor" />

      <div class="shadow p-5 mt-2 mb-5 bg-white rounded">
        <LaborForm
          :model="labor"
          :save-function="updateLabor"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import PageHeader from '@/components/app/AppPageHeader.vue'
import { Labor } from '@/models/labor'
import { useHead } from '@unhead/vue'
import LaborForm from '../components/LaborForm.vue'
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import { useQuery, useMutation, useQueryClient } from '@tanstack/vue-query'
import LaborService from '@/services/LaborService'
import { useRoute, useRouter } from 'vue-router'
import { useNotification } from '@kyvg/vue3-notification'

useHead({ title: 'Edit Labor' })

const $router = useRouter()
const $route = useRoute()
const laborId = $route.params.id as string || ''
const laborService = new LaborService()
const queryClient = useQueryClient()
const { notify } = useNotification()

const { data: labor, isLoading } = useQuery({
  queryKey: ['labor', laborId],
  queryFn: () => laborService.find(laborId)
})

const { mutateAsync: updateLabor } = useMutation({
  mutationFn: (labor: Labor) => laborService.update(laborId, labor),
  onSuccess: (updatedLabor:Labor) => {
    queryClient.setQueryData(['labor', updatedLabor.id], updatedLabor)
    queryClient.invalidateQueries({ queryKey: ['labors'] })
    notify({
      type: 'success',
      title: 'Labor updated',
      text: 'Labor updated successfully'
    })
    $router.push({ name: 'ListLabor' })
  },
  onError: (error) => {
    notify({
      type: 'error',
      title: 'Error',
      text: error.message || 'An error occurred while trying to update the labor'
    })
  }
})
</script>
